import React from 'react';

const Footer = () => {
    return (
      <footer
        style={{
          backgroundColor: ' rgba(166, 117, 25, 0.863)',
          color: '#fff',
          padding: '20px',
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
          }}
        >
          <p style={{ fontSize: '14px' }}>© 2025 All Rights Reserved. Powered by Deliverance Church Utawala.</p>
        </div>
      </footer>
    );
  };
export default Footer  